import { Colors, LoaderSize } from 'enums';
import styled from 'styled-components';

export const $Spinner = styled.div`
    width: ${({ size }) => (size === LoaderSize.Big ? '80px' : '50px')};
    height: ${({ size }) => {
        if (size === LoaderSize.Big) {
            return '80px';
        }
        if (size === LoaderSize.Small) {
            return '20px';
        }
        return '50px';
    }};
`;

export const $Bar = styled.div`
    background-color: ${({ highlight }) => {
        if (highlight) {
            return Colors.Orange;
        }
        return Colors.White;
    }};

    height: 100%;
    width: ${({ size }) => {
        if (size === LoaderSize.Small) {
            return '3px';
        }
        return '6px';
    }};
    margin-left: 1px;
    display: inline-block;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;

    :nth-child(1) {
        margin: 0;
    }

    :nth-child(2) {
        animation-delay: -1.1s;
    }

    :nth-child(3) {
        animation-delay: -1s;
    }

    :nth-child(4) {
        animation-delay: -0.9s;
    }

    :nth-child(5) {
        animation-delay: -0.8s;
    }

    @keyframes sk-stretchdelay {
        0%,
        40%,
        100% {
            transform: scaleY(0.4);
        }
        20% {
            transform: scaleY(1);
        }
    }
`;
